var map = {
	"./DandL.png": "e145",
	"./Our-logo.png": "3738",
	"./allTeam.png": "7735",
	"./border_text.png": "0bd2",
	"./eachforequal.png": "32ad",
	"./main_background.png": "1744",
	"./svg/vision-icon.svg": "ce8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d85";